import { DatePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TooltipModule } from '@openng/optimus-ui/tooltip';

import { JobBoardService } from '@app/shared/services/job-board.service';

@Component({
    selector: 'cor-refresh-job-data',
    templateUrl: './refresh-job-data.component.html',
    imports: [TooltipModule, DatePipe],
})
export class RefreshJobDataComponent {
    protected readonly displayText = input(true);

    protected readonly displayIcon = input(true);

    private readonly jobBoardService = inject(JobBoardService);

    protected readonly isLoading = computed(() => this.jobBoardService.isLoading());

    protected readonly lastUpdatedTime = this.jobBoardService.lastUpdatedTime.asReadonly();

    protected readonly jobBoardPollingIntervalInSeconds = computed(
        () => this.jobBoardService.jobPullInterval() / 1000,
    );

    onRefresh() {
        if (!this.isLoading()) {
            this.jobBoardService.fetchJobBoardData();
        }
    }
}
